import type { CrossFlowExtensions } from '@atlassiansox/cross-flow-base-types';

import { type ProvisioningPageExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export type { ProvisioningPageExtensionsOptions } from './types';

export const provisioningPageExtensionsWhitelist: string[] = ['provisioningPageOptions'];

export const createProvisioningPageExtensions = (
	options: ProvisioningPageExtensionsOptions,
): CrossFlowExtensions =>
	createProductExtensions<{
		provisioningPageOptions: ProvisioningPageExtensionsOptions;
	}>(provisioningPageExtensionsWhitelist)({
		provisioningPageOptions: options,
	});
